/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const RoundUp = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M18.25 1L22.7803 5.53033L21.7197 6.59099L19 3.872V13.8107C19 18.9193 14.8586 23.0607 9.75 23.0607H9.5C4.80558 23.0607 1 19.2551 1 14.5607C1 9.86624 4.80558 6.06066 9.5 6.06066C10.3705 6.06066 11.2103 6.1915 12.0011 6.43459L12.0007 8.02056C11.2241 7.72344 10.3811 7.56066 9.5 7.56066C5.63401 7.56066 2.5 10.6947 2.5 14.5607C2.5 18.4267 5.63401 21.5607 9.5 21.5607C9.66825 21.5607 9.83511 21.5547 10.0004 21.543L10 21.5567C14.1645 21.4247 17.5 18.0072 17.5 13.8107V3.87L14.7803 6.59099L13.7197 5.53033L18.25 1ZM10.114 10.3107V11.1297C11.221 11.3187 11.941 12.0387 11.995 13.0827H10.627C10.555 12.6867 10.168 12.3087 9.538 12.3087C8.998 12.3087 8.674 12.5247 8.674 12.8937C8.674 13.2267 8.926 13.3887 9.304 13.4967L10.285 13.7667C11.221 14.0367 12.031 14.4597 12.031 15.7647C12.031 16.7997 11.293 17.5287 10.114 17.6817V18.5457H8.971V17.6547C7.819 17.4387 7.054 16.6017 7 15.3957H8.368C8.422 16.0167 8.944 16.5027 9.61 16.5027C10.204 16.5027 10.609 16.2237 10.609 15.8007C10.609 15.4317 10.312 15.2157 9.916 15.0987L8.944 14.8287C8.017 14.5767 7.243 14.1087 7.243 12.9027C7.243 12.0027 7.945 11.3187 8.971 11.1297V10.3107H10.114Z"
                        fill={color}
                    />
                </svg>
        );
    };
